angular
  .module('pb.user')

  .factory('ResourceCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class ResourceCrud extends Crud {
        constructor() {
          super(null, '@@apiUrl' + '/resources');
        }
      }

      return ResourceCrud;
    }
  ]);
